/* global angular */

angular.module('atex.aceui.application').factory('Application',
  [function () {
    var API = {},
      settings = {},
      user = {};

    /**
   * Application.settings:
   */

    Object.defineProperty(settings, 'prefix', {
      get: function () { return this._prefix || 'aceui'; },
      set: function (prefix) { this._prefix = prefix; }
    });

    Object.defineProperty(settings, 'useCookies', {
      get: function () {
        if (typeof this._useCookies === 'undefined') {
          return true;
        } else {
          return this._useCookies;
        }
      },

      set: function (useCookies) { this._useCookies = useCookies; }
    });

    Object.defineProperty(settings, 'TOKEN_KEY', {
      get: function () { return this.prefix + '.currentUser.token'; }
    });

    Object.defineProperty(settings, 'USERID_KEY', {
      get: function () { return this.prefix + '.currentUser.userId'; }
    });

    Object.defineProperty(settings, 'PRINCIPALID_KEY', {
      get: function () { return this.prefix + '.currentUser.principalId'; }
    });

    Object.defineProperty(settings, 'USERNAME_KEY', {
      get: function () { return this.prefix + '.currentUser.username'; }
    });

    Object.defineProperty(API, 'settings', {
      get: function () { return settings; }
    });

    /**
   * Application.currentUser:
   */

    Object.defineProperty(user, 'userId', {
      get: function () {
        return localStorage[API.settings.USERID_KEY];
      },

      set: function (userId) {
        localStorage[API.settings.USERID_KEY] = userId;
      }
    });

    Object.defineProperty(user, 'principalId', {
      get: function () {
        return localStorage[API.settings.PRINCIPALID_KEY];
      },

      set: function (principalId) {
        localStorage[API.settings.PRINCIPALID_KEY] = principalId;
      }
    });

    Object.defineProperty(user, 'token', {
      get: function () {
        return localStorage[API.settings.TOKEN_KEY];
      },

      set: function (token) {
        localStorage[API.settings.TOKEN_KEY] = token;
      }
    });

    Object.defineProperty(user, 'username', {
      get: function () {
        return localStorage[API.settings.USERNAME_KEY];
      },

      set: function (username) {
        localStorage[API.settings.USERNAME_KEY] = username;
      }
    });

    Object.defineProperty(API, 'currentUser', {
      get: function () {
        return user;
      },

      set: function (newUser) {
        user.userId = newUser.userId || user.userId;
        user.principalId = newUser.principalId || user.principalId;
        user.token = newUser.token || user.token;
        user.username = newUser.username || user.username;
      }
    });

    /**
   * Application.currentErrorInfo:
   */

    Object.defineProperty(API, 'currentErrorInfo', {
      get: function () {
        return this._currentErrorInfo;
      },

      set: function (errorInfo) {
        this._currentErrorInfo = errorInfo;
      }
    });

    /**
   * Application.setCookies().
   *
   * Sets browser cookies for 'userId' and 'sessionKey' based
   * on what is currently stored in browser localStorage.
   *
   * Does not return anything.
   */
    API.setCookies = function () {
      if (document && API.settings.useCookies) {
        if (API.currentUser.userId === undefined || API.currentUser.token === undefined) {
          console.log('No userId or token set! Can not set cookies...');
          return;
        }

        document.cookie = 'userId=' + API.currentUser.userId + '; path=/; SameSite=None; Secure;';
        document.cookie = 'sessionKey=' + API.currentUser.token.split('::')[1] + '; path=/ SameSite=None; Secure;';
      }
    };

    /**
   * Application.reset().
   *
   * Resets all current browser user state, both in localStorage and cookies.
   *
   * Does not return anything.
   */
    API.reset = function () {
      localStorage.removeItem(API.settings.USERID_KEY);
      localStorage.removeItem(API.settings.PRINCIPALID_KEY);
      localStorage.removeItem(API.settings.TOKEN_KEY);
      localStorage.removeItem(API.settings.USERNAME_KEY);

      if (document && API.settings.useCookies) {
        window.document.cookie = 'userId=; path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        window.document.cookie = 'sessionKey=; path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      }
    };

    return API;
  }]);
